import "./switcher.css";

export const designRoutes = ["1", "2", "3", "4", "5"];

export default function Switcher({ current }) {
  return (
    <nav className="design-switcher" aria-label="Design concepts">
      <a href="/">Home</a>
      {designRoutes.map((route) => (
        <a key={route} href={`/${route}`} aria-current={route === String(current) ? "page" : undefined}>
          {route}
        </a>
      ))}
    </nav>
  );
}
